/* Wrought: size and fit shown on the product page itself.
   Measurements are the ones already published on /pages/size-guide (garment, laid flat).
   Products without a published chart show their fit note and a link to the full guide. */
(function () {
  var P = window.wrProduct; if (!P || !P.handle) return;
  var TEE = { XS: ['32–34', '27'], S: ['34–37', '28'], M: ['38–41', '29'], L: ['42–45', '30'], XL: ['46–49', '31'], '2XL': ['50–53', '32'], '3XL': ['54–57', '33'] };
  var LONG = { S: ['34–37', '29'], M: ['38–41', '30'], L: ['42–45', '31'], XL: ['46–49', '32'], '2XL': ['50–53', '33'] };
  var OVERSIZED = ['oversized-high-neck-tee', 'why-not-me-high-neck-tee', 'sunworn-oversized-tee'];
  var chart = null;
  if (P.handle === 'armor-tee-long-sleeve') chart = LONG;
  else if (OVERSIZED.indexOf(P.handle) === -1 && (P.type === 'T-Shirt' || P.type === 'Tank Top')) chart = TEE;
  var sizes = Array.isArray(P.sizes) ? P.sizes : [];
  if (!sizes.length) return; // caps, flag: one size, nothing to chart

  function fitNote() {
    var out = '';
    document.querySelectorAll('main p').forEach(function (p) {
      var s = p.querySelector('strong');
      if (!out && s && /^fit:?$/i.test(s.textContent.trim())) out = p.textContent.replace(/^\s*fit:?\s*/i, '').replace(/\s*check the size chart[^.]*\.?/i, '').trim();
    });
    return out;
  }

  function build() {
    if (document.querySelector('.wr-sz')) return true;
    var form = document.querySelector('main product-form-component') || document.querySelector('main form.shopify-product-form');
    if (!form) return false;
    var picker = document.querySelector('main variant-picker');
    var rows = '';
    if (chart) sizes.forEach(function (s) { if (chart[s]) rows += '<tr><th scope="row">' + s + '</th><td>' + chart[s][0] + '</td><td>' + chart[s][1] + '</td></tr>'; });
    var fit = fitNote().replace(/</g, '&lt;');
    var el = document.createElement('details');
    el.className = 'wr-sz';
    el.innerHTML =
      '<summary><span class="wr-sz__hd">Size and fit</span>' + (fit ? '<span class="wr-sz__fit">' + fit + '</span>' : '') + '<span class="wr-sz__more">' + (rows ? 'See measurements' : 'More on sizing') + '</span></summary>' +
      (rows ? '<table class="wr-sz__t"><thead><tr><th scope="col">Size</th><th scope="col">Chest (in)</th><th scope="col">Length (in)</th></tr></thead><tbody>' + rows + '</tbody></table>' +
        '<p class="wr-sz__ft">Garment measurements, laid flat. Chest is armpit to armpit, doubled. Can vary by about 1 inch.</p>' : '') +
      '<p class="wr-sz__ft">Made to order, so we can\'t exchange for size. <a href="/pages/size-guide">Full size guide</a> &nbsp;/&nbsp; <a href="/pages/contact">Ask us before you buy</a></p>';
    if (picker && picker.parentNode) picker.parentNode.insertBefore(el, picker.nextSibling);
    else form.parentNode.insertBefore(el, form);
    return true;
  }

  var css = document.createElement('style');
  css.textContent =
    '.wr-sz{margin:14px 0;padding:14px 16px;border:1px solid #262523;border-radius:6px;font-size:13px;color:#b4b2a9}' +
    '.wr-sz summary{list-style:none;cursor:pointer;display:block}' +
    '.wr-sz summary::-webkit-details-marker{display:none}' +
    '.wr-sz__hd{display:block;color:#888780;font-size:11px;letter-spacing:.14em;text-transform:uppercase;margin-bottom:6px}' +
    '.wr-sz__fit{display:block;font-size:14px;line-height:1.5;color:#ece9e1}' +
    '.wr-sz__more{display:inline-block;margin-top:8px;font-size:13px;color:#ece9e1;text-decoration:underline;text-underline-offset:3px}' +
    '.wr-sz[open] .wr-sz__more{display:none}' +
    '.wr-sz__t{width:100%;border-collapse:collapse;margin:14px 0 10px;font-size:13px}' +
    '.wr-sz__t th,.wr-sz__t td{padding:8px 6px;text-align:left;border-bottom:1px solid #262523;font-weight:400}' +
    '.wr-sz__t thead th{color:#888780;font-size:11px;letter-spacing:.1em;text-transform:uppercase}' +
    '.wr-sz__t tbody th{color:#ece9e1}' +
    '.wr-sz__ft{margin:8px 0 0;font-size:12px;line-height:1.5;color:#888780}' +
    '.wr-sz__ft a{color:#ece9e1;text-decoration:underline;text-underline-offset:3px}';
  document.head.appendChild(css);

  var tries = 0;
  (function wait() { if (build() || ++tries > 40) return; setTimeout(wait, 250); })();

  // Existing "Size Guide" links jump to the block instead of leaving the product page.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/pages/size-guide"]');
    var el = document.querySelector('.wr-sz');
    if (!a || !el || a.closest('.wr-sz') || !el.querySelector('.wr-sz__t')) return;
    e.preventDefault();
    el.open = true;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);
})();
